module.exports = __webpack_public_path__ + "static/media/ibd_foot1.8514907a.png";